import { render, staticRenderFns } from "./LawResultBox.vue?vue&type=template&id=b71f2ef6&scoped=true&"
import script from "./LawResultBox.vue?vue&type=script&lang=js&"
export * from "./LawResultBox.vue?vue&type=script&lang=js&"
import style0 from "./LawResultBox.vue?vue&type=style&index=0&id=b71f2ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71f2ef6",
  null
  
)

export default component.exports